import { useAnimation } from '@angular/animations';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Numbers } from 'src/app/utils/constants';
import { InputModel } from '../../../../core/models/input.model';

import { CommonService } from '../../../../core/providers/forms/common.service';

@Component({
  selector: 'app-input-btn',
  templateUrl: './input-btn.component.html',
  styleUrls: ['./input-btn.component.scss']
})
export class InputBtnComponent implements OnInit, OnChanges {

  public currValue = '';

  /**
   * @description se le pasa el formulario base
   */
  @Input() FORM_DATA: FormGroup;
  @Input() DATA_CONFIG: InputModel;
  @Input() DATA_CONFIG_FULL: any;
  @Input() DATA_CHANGE: any;
  @Input() STEP: any;
  @Output() DATA_EMIT: EventEmitter<any> = new EventEmitter();

  @ViewChild('promoCode', { static: false }) input: ElementRef;

  fieldName: any;
  fieldErrors: any;
  fieldHasErrorB = false;
  fieldTouch = false;
  fieldRequired = false;
  maxlengthNum: number;
  servicePromoError = false;
  finish = new Subject();
  isDisabled = false;
  number5 = 5;
  number10 = 10;
  /**
   * @description se le pasa un array de strings que será el path que enlazará
   *  la propiedad del formulario al input
   * @example ['individualTravelAsistance', 'name']
   */

  constructor(
  ) { }
  /**
   * @description Metodo de inicio
   */
  ngOnInit() {
    // Si viene un valor del formulario o de la configuracion lo guardamos en el formulario
    if (this.DATA_CONFIG.value && this.DATA_CONFIG.value.length > 0) {
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(this.DATA_CONFIG.value);
    } else {
      if (this.getFormValue() && this.getFormValue().length > 0) {
        this.currValue = this.getFormValue();
      }
    }

    this.fieldName = this.DATA_CONFIG.linkFormPath;
    this.fieldRequired = false;
    this.maxlengthNum = parseInt(this.DATA_CONFIG.maxlength, Numbers.number10);
    this.isDisabled = false;
    if (this.DATA_CONFIG.disabled !== undefined) { this.isDisabled = this.DATA_CONFIG.disabled; }
    this.getError(this.fieldName);

    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(el => {
          if (this.STEP !== undefined) {
            //
          }
        })
      ).subscribe();
  }
  /**
   * @description Metodo de cambio
   * @params changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.DATA_CHANGE !== undefined && changes.DATA_CHANGE.currentValue !== undefined) {
      const AUX_CHANGE: any = changes.DATA_CHANGE.currentValue;
      if (AUX_CHANGE.name !== undefined && AUX_CHANGE.name === 'promo' && AUX_CHANGE.value === 'error') {
        this.servicePromoError = true;
        this.fieldHasErrorB = true;
        this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
      }
    }
  }

  /**
   * @description Es para comprobar que todos los inputs tienen datos para poder iniciar el componente
   */
  public checkDataCompOk(): boolean {
    return this.FORM_DATA && this.DATA_CONFIG && this.DATA_CONFIG.linkFormPath && this.DATA_CONFIG.linkFormPath.length > 0;
  }
  /**
   * @description evento click del input
   */
  clickInput(): void {
    this.DATA_EMIT.emit({ enter: true });
  }

  /**
   * @description Actualiza los cambios del input desde el html
   */
  public updateData(ev: { target: { value: string } }): void {
    if (!this.checkDataCompOk()) { return; }
    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(ev.target.value);

    if (this.fieldRequired && ev.target.value !== '') {
      // if (auxV !== '') {
      this.fieldHasErrorB = false;
      let errorsA: any = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) {
        errorsA = null;
      } else {
        errorsA = ERRORS;
      }

      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors(errorsA);
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).updateValueAndValidity();
    } else if (this.fieldRequired) {
      this.fieldHasErrorB = true;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    } else {
      this.fieldHasErrorB = false;
      this.servicePromoError = false;
      let errorsA: any = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) {
        errorsA = null;
      } else {
        errorsA = ERRORS;
      }

      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors(errorsA);
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).updateValueAndValidity();
    }
  }

  /**
   * @description Actualiza los cambios del input desde el html
   */
  public getFormValue(): string {
    if (this.checkDataCompOk()) {
      return this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
    }
  }

  /**
   *
   * @param field field to mark focus
   */
  onFocusInput(controlName: any): void {
    this.FORM_DATA.get(controlName).markAsUntouched();
    this.fieldTouch = true;
    const VALUE_EL: any = this.FORM_DATA.get(controlName).value;
    if (this.fieldRequired && VALUE_EL !== '') {
      this.fieldHasErrorB = false;
    }
    if (this.fieldRequired && VALUE_EL === '') {
      this.fieldHasErrorB = true;
    }
  }

  /**
   *
   * @param field field to check erros
   */
  getError(controlName: string): string {
    let errorMsg = '';
    this.fieldErrors = '';
    this.fieldRequired = this.DATA_CONFIG.required;
    const CONTROL: AbstractControl = this.FORM_DATA.get(controlName);

    if (CONTROL.invalid && CONTROL.errors !== null) {
      errorMsg = JSON.stringify(CONTROL.errors);
      this.fieldErrors = CONTROL.errors;
      if (this.fieldErrors.pattern) {
        //
      }
    }


    return errorMsg;
  }

  /**
   *
   * @param field field to check key
   */
  onKeydown(event: any): void {
    if (event.key === 'Enter') {
      this.DATA_EMIT.emit({ enter: true });
      event.preventDefault();
    }
  }

  /**
   *
   * @param field field to check 5 caracters
   */
  lengthField(event: any): void {
    const AUX_LENGTH: any = event.target.value;
    if (AUX_LENGTH.length === Numbers.number5) {
      this.DATA_EMIT.emit({ enter: true });
    }
  }

}
